import { gql } from '@apollo/client';

export const GET_DOOPIE_REGISTER = gql`
  query GetDoopieRegister(
    $where: DoopiePreRegisterWhereInput
    $sort: SortOrderInput
  ) {
    getDoopieRegister(where: $where, sort: $sort) {
      id
      solanaAddress
    }
  }
`;
